import BasePageView from "components/core/BasePageView/BasePageView";
import usePurchaseOrderListLogic from "./usePurchaseOrderListLogic";
import PurchaseOrderListDesktop from "./PurchaseOrderListDesktop";
import PurchaseOrderListMobile from "./PurchaseOrderListMobile";
import useSellerContext from "hooks/useSellerContext";

const PurchaseOrderListView = () => {
  const vm = usePurchaseOrderListLogic();
  const { currentSellerDetail, allSellersDetails, handleProfileNavigate } = useSellerContext();

  return (
    <BasePageView
      DesktopView={PurchaseOrderListDesktop}
      MobileView={PurchaseOrderListMobile}
      viewProps={vm}
      headerProps={{
        showSubHeader: true,
        sellerDetail: currentSellerDetail,
        allSellerDetails: allSellersDetails,
        handleProfile: handleProfileNavigate,
      }}
    />
  );
};

export default PurchaseOrderListView;
